<template>
    <div class="BrandResultInfoItem " v-if="isVisible">
        <div v-if="isLoading" class="text-center py-4">
            <PageLoader :loading="isLoading" />
        </div>

        <div v-else class="raw pt-4"
             v-for="(item, index) in details.contents" :key="index">

            <div class="BrandResultProfile">
                <img :src="getInfluencerImage(item)" class="BrandResultProfileImg" />
                <h3 class="uppercase BrandResultProfileHeadline">{{ item.influencer.name }}</h3>
            </div>

            <brand-result-info
                :title="'Total for influencer'"
                :campaign="campaign"
                :insight="item.insight"
                :influencer="item.influencer"
                :image="null"
                :isShowTooltip="false"
                :isInfoDetail="true"
            />

            <brand-result-posts :posts="item.posts" />
        </div>
    </div>
</template>

<style type="text/less" lang="less">

.BrandResultInfoItem {
    border-bottom: 10px solid #1825D8;

    h4 {
        font-size: 30px;
        font-weight: 900;
        letter-spacing: 9px;
        color: #1D2CF3;
    }
}

@media (max-width: 767px) {
    .BrandResultInfoItem {
        h4 {
            font-size: 16px;
            letter-spacing: 4px;
        }
    }
}

.BrandResultProfile {
    display: flex;
    align-items: center;

    img {
        width: 54px;
        height: 54px;
        border-radius: 50%;
        margin-right: 20px;
    }
    .BrandResultProfileHeadline {
        font-size: 22px;
        font-weight: 700;
        color: #000 !important;
        font-family: "Brandon Grotesque", 'HvDTrial Brandon Grotesque', serif;
    }
}
</style>

<script type="text/babel">
import BrandResultInfo from 'dashboard-js/components/brands/BrandResultInfo';
import BrandResultPosts from 'dashboard-js/components/brands/BrandResultPosts';
import PageLoader from 'dashboard-js/components/utilities/PageLoader';

export default {
    components: {
        BrandResultInfo,
        BrandResultPosts,
        PageLoader
    },

    data: () => ({
        isLoading: false,
        details: null
    }),

    props: ['isVisible', 'campaign', 'url'],

    watch: {
        isVisible: function (val) {
            if (val !== true
                || this.details !== null
                || this.url === null
            ) {
                return;
            }

            this.isLoading = true;

            axios.get(this.url)
                .then(response => {
                    this.details = response.data;
                })
                .catch(error => {
                    console.log(error);
                })
                .finally(() => {
                    this.isLoading = false;
                });
        }
    },

    methods: {
        getInfluencerImage: function (item) {
            if (item.influencer.images && item.influencer.images.length) {
                return item.influencer.images[0].url;
            }

            return item.default_image;
        }
    }
}
</script>
